/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkCreateUserRequest} from '../models/BulkCreateUserRequest';
import type {BulkProgress} from '../models/BulkProgress';
import type {CreateUsersResponse} from '../models/CreateUsersResponse';
import type {Error} from '../models/Error';

export interface GetUserCreationProgress$Request {
    id: string;
}

export interface GetUserCreationProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserCreationProgressRequest = createAction<PayloadData<void, GetUserCreationProgress$Request>>('BULK_USER_CREATION__GET_USER_CREATION_PROGRESS__REQUEST');
export const getUserCreationProgressSuccess = createAction<PayloadData<BulkProgress, GetUserCreationProgress$Request>>('BULK_USER_CREATION__GET_USER_CREATION_PROGRESS__SUCCESS');
export const getUserCreationProgressFailure = createAction<PayloadData<Error, GetUserCreationProgress$Request, true>>('BULK_USER_CREATION__GET_USER_CREATION_PROGRESS__FAILURE');

export const getUserCreationProgressActions = [
    getUserCreationProgressRequest,
    getUserCreationProgressSuccess,
    getUserCreationProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserCreationProgress = (meta: GetUserCreationProgress$Request, config?: GetUserCreationProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUserCreationProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersCreationResult$Request {
    id: string;
}

export interface GetUsersCreationResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersCreationResultRequest = createAction<PayloadData<void, GetUsersCreationResult$Request>>('BULK_USER_CREATION__GET_USERS_CREATION_RESULT__REQUEST');
export const getUsersCreationResultSuccess = createAction<PayloadData<CreateUsersResponse, GetUsersCreationResult$Request>>('BULK_USER_CREATION__GET_USERS_CREATION_RESULT__SUCCESS');
export const getUsersCreationResultFailure = createAction<PayloadData<Error, GetUsersCreationResult$Request, true>>('BULK_USER_CREATION__GET_USERS_CREATION_RESULT__FAILURE');

export const getUsersCreationResultActions = [
    getUsersCreationResultRequest,
    getUsersCreationResultSuccess,
    getUsersCreationResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersCreationResult = (meta: GetUsersCreationResult$Request, config?: GetUsersCreationResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUsersCreationResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopUserCreationAction$Request {
    id: string;
}

export interface StopUserCreationAction$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopUserCreationActionRequest = createAction<PayloadData<void, StopUserCreationAction$Request>>('BULK_USER_CREATION__STOP_USER_CREATION_ACTION__REQUEST');
export const stopUserCreationActionSuccess = createAction<PayloadData<void, StopUserCreationAction$Request>>('BULK_USER_CREATION__STOP_USER_CREATION_ACTION__SUCCESS');
export const stopUserCreationActionFailure = createAction<PayloadData<Error, StopUserCreationAction$Request, true>>('BULK_USER_CREATION__STOP_USER_CREATION_ACTION__FAILURE');

export const stopUserCreationActionActions = [
    stopUserCreationActionRequest,
    stopUserCreationActionSuccess,
    stopUserCreationActionFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopUserCreationAction = (meta: StopUserCreationAction$Request, config?: StopUserCreationAction$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopUserCreationActionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UserBulkCreation$Request {
    bulkCreateUserRequest: Array<BulkCreateUserRequest>;
    reason?: string;
}

export interface UserBulkCreation$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userBulkCreationRequest = createAction<PayloadData<void, UserBulkCreation$Request>>('BULK_USER_CREATION__USER_BULK_CREATION__REQUEST');
export const userBulkCreationSuccess = createAction<PayloadData<string, UserBulkCreation$Request>>('BULK_USER_CREATION__USER_BULK_CREATION__SUCCESS');
export const userBulkCreationFailure = createAction<PayloadData<Error, UserBulkCreation$Request, true>>('BULK_USER_CREATION__USER_BULK_CREATION__FAILURE');

export const userBulkCreationActions = [
    userBulkCreationRequest,
    userBulkCreationSuccess,
    userBulkCreationFailure
] as const;

/**
 * @param {Array<BulkCreateUserRequest>} meta.bulkCreateUserRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userBulkCreation = (meta: UserBulkCreation$Request, config?: UserBulkCreation$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: userBulkCreationActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/users`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.bulkCreateUserRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

